<template>
  <panel-navigation>

    <div class="flex flex-row items-top justify-between">
      <h1 class="text-lg font-semibold mb-3">Roll Up Report (last 7 days)</h1>
    </div>

    <div class="">
      <template>
        <v-row class="my-3 mt-0 rg-top-filter">
            <v-col cols="12" md="4" sm="4" xs="6">
                <v-text-field
                        clearable
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        label="Search"
                        v-model="search"

                        class="white border border-white"
                ></v-text-field>
            </v-col>
            <template>
                <v-col cols="12" md="4" sm="4" xs="6">
                    <!-- <v-select
                            outlined
                            dense
                            hide-details
                            label="Tags"
                            class="white header-inputs"
                            :item-text="item => item.text"
                            :item-value="item => item.index"
                            :items="tags_items"
                            v-model="tag"
                            clearable
                    ></v-select> -->
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="4" sm="4" xs="6">
                    <div class="float-left" style="width: calc(100% - 85px);">
                        <v-select
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Response Rate"
                                :item-text="item => item.text"
                                :item-value="item => item.index"
                                class="white header-inputs"
                                :items="response_rate_items"
                                v-model="response_rate"
                                clearable
                        >
                          <template slot="selection" slot-scope="data">
                            <b-icon
                                icon="circle-fill"
                                scale="2"
                                :variant="((data.item.index == 0) ? 'success' : ((data.item.index == 2) ? 'danger' : 'warning'))"
                                style="height: 5px"
                                class="mr-2"
                              ></b-icon>
                              
                              <span class="text-sm">{{ data.item.text }}</span>
                          </template>
                          <template slot="item" slot-scope="data">
                            <b-icon
                                icon="circle-fill"
                                scale="2"
                                :variant="((data.item.index == 0) ? 'success' : ((data.item.index == 2) ? 'danger' : 'warning'))"
                                style="height: 5px"
                                class="mr-2"
                              ></b-icon>
                              
                              <span class="text-sm">{{ data.item.text }}</span>
                          </template>
                        </v-select>
                    </div>

                    <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 rounded cursor-pointer float-right ml-2" style="padding-bottom: 11px; padding-top: 11px;"
                        @click="getRollUpReport();"
                    >
                        Filter
                    </div>
                </v-col>
            </template>
        </v-row>
    </template>
    <template>
        <div class="dashboard-box">
            <v-card class="pa-2" tile>
                <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                <div v-else class="p-3">
                  <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>
                    <div v-if="items.length == 0">
                        <br/><br/><br/><br/>
                        <div class="dashboard-box-iconsquare">
                            <div class="dashboard-box-icon-background"></div>
                            <div class="dashboard-box-icon">
                                <i class="mdi mdi-chart-bar"></i>
                            </div>
                        </div>
                        <div style="text-align: center;">
                            <div class="pt-2 pb-2">
                                <strong>No Data</strong>
                            </div>

                            <div class="text-sm mb-4 text-gray-600">
                                No data found for your roll up report.
                            </div>
                            <br/>
                        </div>
                        <br/><br/><br/><br/><br/>
                    </div>

                    <div v-else style="clear: both; padding-top: 0px;">
                      <div v-if="$vuetify.breakpoint.mobile" class="mt-7">
                        <div v-for="(business, index) in items" :key="index" style="">
                          <div><strong>{{ business.company_name }}</strong></div>
                          <div><a :href="'mailto:' + business.email">{{ business.email }}</a></div>

                          <div style="padding-top: 10px;">
                            <strong>Response Rate: </strong> <span>
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.response_rate >= 95) ? 'success' : ((business.response_rate < 90) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.response_rate }} %
                              </span>
                            <br />
                            <strong>Number of Reviews: </strong> <span>
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.number_of_reviews >= 100) ? 'success' : ((business.number_of_reviews < 50) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.number_of_reviews }}
                              </span>
                            <br />
                            <strong># Of Leads: </strong> <span>
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.number_of_leads >= 100) ? 'success' : ((business.number_of_leads < 50) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.number_of_leads }}
                              </span>
                            <br />
                          </div>
                          <hr class="mt-2 mb-2" />
                        </div>
                      </div>
                      <table v-else class="w-full rg-datatable datatable">
                        <thead class="border-b border-gray-100 w-full">
                          <tr class="tableHeader">
                            <th>Business Name</th>
                            <th>Location</th>
                            <th>Response Rate</th>
                            <th>Number of Reviews</th>
                            <th># Of Leads</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody class="w-full" style="">
                          <tr v-for="(business, index) in items" :key="index">
                            <td>
                              {{ business.company_name }}<br />
                              <a :href="'mailto:' + business.email">{{ business.email }}</a>
                            </td>
                            <td>{{ business.address }}, {{ business.city }} {{ business.state }}</td>
                            <td>
                              <span class="flex">
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.response_rate >= 95) ? 'success' : ((business.response_rate < 90) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.response_rate }} %
                              </span>
                            </td>
                            <td>
                              <span class="flex">
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.number_of_reviews >= 100) ? 'success' : ((business.number_of_reviews < 50) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.number_of_reviews }}
                              </span>
                            </td>
                            <td>
                              <span class="flex">
                                <b-icon
                                  icon="circle-fill"
                                  scale="2"
                                  :variant="((business.number_of_leads >= 100) ? 'success' : ((business.number_of_leads < 50) ? 'danger' : 'warning'))"
                                  style="height: 5px"
                                  class="mt-2 mr-2"
                                ></b-icon>
                                {{ business.number_of_leads }}
                              </span>
                            </td>
                            <td style="text-align: right">
                              <a href="javascript: void(0);" class="text-xs font-semibold rounded cursor-pointer" @click="manageAccount(business)">
                                <i class="fa fa-sign-in-alt mr-2 text-purple"></i>
                                <span class="whitespace-no-wrap text-purple">Manage ACCOUNT</span>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
            </v-card>
        </div>
    </template>

    
      <template v-if="items.length > 0">
        <div class="dashboard-box">
          <v-card class="pa-2" tile>
            <div class="p-3">
              <div class="overflow-x-scroll">
                
              </div>
            </div>
          </v-card>
        </div>
      </template>
    </div>
  </panel-navigation>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
import PanelNavigation from "@/components/PanelNavigation.vue";
export default {
  metaInfo() {
    return {
      title: "Agency Reports 1  | " + this.$appName,
    };
  },
  components: {
  },
  data() {
    return {
      items: [],

      loading: false,
      
      search: "",

      tags_items: [{
          index: 0,
          text: 'Not Set'
      },{
          index: 1,
          text: 'Existing Customer'
      },{
          index: 2,
          text: 'Missed Call'
      },{
          index: 3,
          text: 'Opportunity'
      },{
          index: 4,
          text: 'Meeting Scheduled'
      },{
          index: 5,
          text: 'Became Customer'
      }],

      response_rate_items: [{
          index: 0,
          text: '95 % or above'
      },{
          index: 1,
          text: '90 - 95 %'
      },{
          index: 2,
          text: 'Below 90%'
      }],

      tag: "",
      response_rate: "",
    };
  },
  methods: {
    async getRollUpReport(silent = false) {
      let self = this;

      if (!silent)
          this.loading = true;

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/roll-up-report`, {
          // date_filter: this.date_filter,
          search: this.search,
          response_rate: this.response_rate
      }, {
          headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
      })

      this.items = response.data.items;
      this.loading = false;
    },
    async manageAccount(business) {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?id=${business.id}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }});
      // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt);
    },
  },
  computed: {
    ...mapState({
      me: (state) => state.me.me,
      profile: (state) => state.me.profile,
    }),
  },
  created() {
    this.$store.dispatch("me/fetch");
    this.getRollUpReport();
  },
};
</script>

<style scoped>
.custom-text-field .v-input__control input {
  border-color: white !important;
}
.custom-text-field .v-input__control input {
  border-color: white !important;
}

.v-text-field--outlined fieldset {
  border: 1px solid red;
}
.header-inputs {
  border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(
    .v-input--has-state
  )
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: rgba(0, 0, 0, 0.38);
  border-color: white !important;
}

.v-text-field--outlined fieldset {
  border: 1px solid white !important;
}

.rg-datatable th {
  /* background-color: #F7F8F8; */
  /* border: solid 1px #f7f8f8; */
  background: rgba(25, 35, 58, 0.1) !important;
}

.status-chip {
  font-weight: bold;
  text-transform: uppercase;
}

.status-Qualified {
  color: green !important;
  border-color: green !important;
}

.status-inQualified {
  color: red;
  border-color: red;
}

.custom-badge {
  background-color: rgba(0, 230, 130, 0.1) !important;
  color: #09ad95 !important;
}

.tags {
  color: #e0e0e0;
  font-size: small;
  padding-left: 5px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #ccc;
  cursor: pointer;
}

.icon {
  font-size: 24px;
}
</style>
